import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'react-bootstrap'
// import { useLazyQuery, useMutation } from '@apollo/client'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
// import videoStyles from '@assets/scss/pages/video.module.scss'
// import { ShareIcon, SaveIcon } from '@shared/components/ctIcons'
import { pageLoading } from '@shared/libs/allLoader'
// import { getCurrentUser } from '@shared-submodule/sm-libs/menu'
// import { GET_BOOKMARK_DETAILS } from '@graphql/article/article.query'
// import { ADD_BOOKMARK, REMOVE_BOOKMARK } from '@graphql/article/article.mutation'
// import ToastrContext from '@shared/components/toastr/ToastrContext'
import PopularVideos from '@shared/components/popularVideos'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
const UpcomingMatches = dynamic(() => import('@shared/components/widgets/upcomingMatches'))
// import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'
// import { getToken } from '@shared/libs/token'
const ArticleGrid = dynamic(() => import('@shared/components/article/articleGrid'), { loading: () => pageLoading() })
// const SocialShareList = dynamic(() => import('@shared/components/socialShare/shareList'))
// const DownloadApp = dynamic(() => import('@shared/components/downloadApp'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

const VideoDetails = ({ videoData, videoList }) => {
  const { t } = useTranslation()
  // const { dispatch } = useContext(ToastrContext)
  // const [isBookmark, setIsBookmark] = useState(false)
  // const bookmarkId = useRef()
  // const { stateGlobalEvents, dispatchGlobalEvents: editProfileEvent } = useContext(GlobalEventsContext)
  // const [getBookmarkDetails] = useLazyQuery(GET_BOOKMARK_DETAILS, {
  //   fetchPolicy: 'network-only',
  //   onCompleted: (data) => {
  //     if (data && data.getBookmarks) {
  //       setIsBookmark(data?.getBookmarks?.bIsBookmarked)
  //       bookmarkId.current = data?.getBookmarks?._id
  //     }
  //   }
  // })

  // useEffect(() => {
  //   if (getToken()) {
  //     getBookmarkDetails({ variables: { input: { iId: videoData?._id, eType: 'v' } } })
  //   }
  // }, [])

  // const [removeBookmark] = useMutation(REMOVE_BOOKMARK, {
  //   fetchPolicy: 'network-only',
  //   onCompleted: (data) => {
  //     if (data && data.deleteBookmark) {
  //       dispatch({
  //         type: 'SHOW_TOAST',
  //         payload: { message: data.deleteBookmark.sMessage, type: TOAST_TYPE.Success }
  //       })
  //       editProfileEvent({
  //         type: 'CHANGE_PROFILE',
  //         payload: { profileData: { ...stateGlobalEvents.profileData, nBookmarkCount: stateGlobalEvents.profileData.nBookmarkCount - 1 } }
  //       })
  //     }
  //   }
  // })

  // const [addBookmark] = useMutation(ADD_BOOKMARK, {
  //   fetchPolicy: 'network-only',
  //   onCompleted: (data) => {
  //     if (data && data.addUserBookmark) {
  //       bookmarkId.current = data.addUserBookmark?._id
  //       dispatch({
  //         type: 'SHOW_TOAST',
  //         payload: { message: data.addUserBookmark.sMessage, type: TOAST_TYPE.Success }
  //       })
  //       editProfileEvent({
  //         type: 'CHANGE_PROFILE',
  //         payload: { profileData: { ...stateGlobalEvents.profileData, nBookmarkCount: stateGlobalEvents.profileData.nBookmarkCount + 1 } }
  //       })
  //     }
  //   }
  // })

  // function handleBookmark() {
  //   if (getCurrentUser()) {
  //     if (isBookmark) {
  //       removeBookmark({ variables: { input: { _id: bookmarkId.current } } })
  //       setIsBookmark(false)
  //     } else {
  //       addBookmark({ variables: { input: { eBookmarkType: 'v', iVideoId: videoData?._id } } })
  //       setIsBookmark(true)
  //     }
  //   } else {
  //     login()
  //   }
  // }

  // function login() {
  //   dispatch({
  //     type: 'SHOW_TOAST',
  //     payload: { message: <Trans i18nKey="common:YouAreNotLogin" />, type: TOAST_TYPE.Error }
  //   })
  // }

  const { addLeft } = reviveAdData

  return (
    <section className="common-section pt-4 mb-4">
      <Container>
        <Row>
          <Col lg={9} className="left-content">
            <iframe
              className={`${styles.videoMain} d-block`}
              src={`https://${videoData?.oPlayer?.sEmbedUrl}`}
              title={videoData?.sTitle}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            >
            </iframe>
            <div className={`${styles.videoDesc}`}>
              <h2 className="mb-3">{videoData?.sTitle}</h2>
            </div>
            {
              videoList?.length > 0 && (
                <>
                  <h5 className="font-semi">{t('common:RelatedVideos')}</h5>
                  <Row className="equal-height-article">
                    {
                      videoList?.map((video) => {
                        return (
                          <Col key={video?._id} lg={4} sm={12} id={video?._id}>
                            <ArticleGrid data={video} isVideo={true} />
                          </Col>
                        )
                      })
                    }
                  </Row>
                </>
              )
            }
            {/* <DownloadApp /> */}
          </Col>
          <Col lg={3} className="common-sidebar">
            <ATSAds />
            <PopularVideos />
            <UpcomingMatches />
            {/* <AllWidget type={WIDGET.trendingNews} show /> */}
            {/* <GoogleAds
              addId={googleAddData?.addLeft?.addId}
              divId={googleAddData?.addLeft?.divId}
              dimension={googleAddData?.addLeft?.dimension}
              slotId={googleAddData?.addLeft?.slotId}
              className={'sticky_ads'}
            /> */}
            <ReviveAds {...addLeft} className={'sticky_ads'}/>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

VideoDetails.propTypes = {
  videoList: PropTypes.array,
  videoData: PropTypes.object
}

export default VideoDetails
